import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../utils/translations';
import { Card, Button } from '../components/UI';

const PlaceholderPage = ({ title, description, backTo }) => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <Card className="text-center py-12">
          <div className="text-6xl mb-6">🚧</div>
          <h1 className="text-3xl font-bold mb-4">{title}</h1>
          <p className="text-gray-600 mb-8">{description}</p>
          <Button onClick={() => navigate(backTo || -1)}>
            {t('back')}
          </Button>
        </Card>
      </div>
    </Layout>
  );
};

export default PlaceholderPage;